<script setup>
</script>

<template>
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M22.666 29.3334L13.945 20.6124C13.5545 20.2219 13.5545 19.5887 13.945 19.1982L22.666 10.4772"
            stroke="white"
            stroke-width="3"
            stroke-linecap="round"
        />
    </svg>
</template>
